function checkContactForm(){
	
  var i=0;

  if($.trim($("#cmsg").val())==''){

    i++;

    $("#cmsg").focus();

  }




  if($.trim($("#cemail").val())==''){

    i++;

    $("#cemail").focus();

  }else{

    apos=document.getElementById('cemail').value.indexOf("@");
	
    dotpos=document.getElementById('cemail').value.lastIndexOf(".");
	
    if (apos<2 ||dotpos<5)
	
    {

      i++;

      $("#cemail").focus();

    }
	
	
  }



  if($.trim($("#cname").val())==''){

    i++;

    $("#cname").focus();

  }


  if(i==0)

  {


    $.ajax({
     
      type: "POST",
      
      url: "doContact.php",
      
      datatype: "html",
	
      data: { 'email': $("#cemail").val(),'msg': $("#cmsg").val(),'name': $("#cname").val()},
      
      success: function (data) {
	
        //	$("#userInfo").html(data)
		
        $("#cemail").val('');
		
        $("#cname").val('');
		
        $("#cmsg").val('');
		
        $('#thxSub').css("visibility", 'visible');

      }

    });


	
	
  }
	
}

  
jQuery('#submit_btn').on('click', function(e)  {
       
       
  $( "#contact_form" ).submit();
         
});


jQuery(document).ready(function() {
  
    jQuery('.tabs .tab-links a').on('click', function(e)  {
        var currentAttrValue = jQuery(this).attr('href');
 
        // Show/Hide Tabs
       jQuery('.tabs ' + currentAttrValue).siblings().slideUp(400);
		jQuery('.tabs ' + currentAttrValue).delay(400).slideDown(400);
 
        // Change/remove current tab to active
        jQuery(this).parent('li').addClass('active').siblings().removeClass('active');
 
        e.preventDefault();
    });
});